<template>
  <div class="w-100">
    <grid-component
      isResizable
      isReorderable
      :canEdit="checkClaim(CAN_EDIT_VENDOR_RETURNS)"
      :canDelete="checkClaim(CAN_DELETE_VENDOR_RETURNS)"
      :gridId="gridId"
      :itemData="itemData"
      :fields="fields"
      :onEdit="onEdit"
      :onDelete="onDelete"
      :handleRowClick="onRowClick"
      :styleCustom="'height: 160px'"
    />
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
  import { GRID_ID } from '@/shared/constants';
  import GridSettings from '@/shared/components/GridSettings';
  import GridComponent from '@/shared/components/GridComponent';
  import gridFields from './fields';

  export default {
    components: {
      GridSettings,
      GridComponent
    },
    props: {
      partId: {
        type:  [Number, String],
        default: 0,
      },
      purchaseOrderLineId: {
        type:  [Number, String],
        default: 0,
      },
      gridId: {
        type:  String,
        default: GRID_ID.SALES_ORDER_LINES,
      },
      isFilteredList: {
        type: Boolean,
        default: false
      },
      vrmaLinesFiltered: {
        type: Array,
        default: () => []
      }
    },
    data: () => ({
      selectedRowItemId: 0,
      // gridId: GRID_ID.SALES_ORDER_LINES,
      fields: gridFields,
      checkedRowItemIds: [],
    }),
    computed: {
      ...mapGetters('account', ['gridSettingsById']),
      ...mapState('vendorrmas', ['vrmasListByPart']),
      gridSettings() {
        return this.gridSettingsById(this.gridId);
      },
      sortDetails: function() {
        if (this.sortBy) {
          return [{ field: this.sortBy, dir: this.sortOrder.toLowerCase() }];
        }

        if (this.gridSettings.sort) {
          return [
            {
              field: this.gridSettings.sort.sortBy,
              dir: this.gridSettings.sort.sortOrder.toLowerCase(),
            },
          ];
        }

        return [];
      },
      itemData() {
        // if (this.vrmasListByPart == undefined || !this.vrmasListByPart.length) return [];
        // return this.vrmasListByPart.map((vendorRMALine) => ({ ...vendorRMALine, selected: vendorRMALine.id === this.selectedRowItemId }));

        const listItems = this.isFilteredList ? this.vrmaLinesFiltered : this.vrmasListByPart;

        if(listItems == undefined || listItems.length === 0) return [];

        return listItems.map((vendorRMALine) => ({ ...vendorRMALine, selected: vendorRMALine.id === this.selectedRowItemId }));
      },
    },
    methods: {
      ...mapActions('vendorrmas', [ 'getVendorRMAByPart','getVendorRMAByPoLine' ]),
      ...mapMutations('vendorrmas', [ 'setVendorrmasByPart' ]),
      ...mapActions('account', ['saveGridSettings']),
      onRowClick(row) {
        this.selectedRowItemId = row.dataItem.id;
        this.$emit('selectedRMALine', row.dataItem);
      },
      onEdit(data) {
        //this.$emit('showEdit', data);
      },
      onDelete(data) {
        //this.$emit('showDelete', data);
      },
    },
    watch: {
      partId() {
        this.setVendorrmasByPart([]);
        if(this.partId) {
          this.getVendorRMAByPart(this.partId);
        }
      },
      purchaseOrderLineId() {
        this.setVendorrmasByPart([]);
        if(this.purchaseOrderLineId) {
          this.getVendorRMAByPoLine(this.purchaseOrderLineId);
        }
      },
      selectedRowItemId(newVal) {
        //const selectedRow = this.vrmasListByPart.find(vendorRMALine => vendorRMALine.id === newVal);
      },
    },
    mounted() {
      this.setVendorrmasByPart([]);
      if(this.partId) {
        this.getVendorRMAByPart(this.partId);
      }
      if(this.purchaseOrderLineId) {
        this.getVendorRMAByPoLine(this.purchaseOrderLineId);
      }
    },
  };
</script>